/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UpdateBagelQuestionRequest } from '../models/update-bagel-question.request';
import { BagelQuestion } from '../models/bagel-question.entity';
import { UpdateBagelQuestionV3Request } from '../models/update-bagel-question-v3.request';

export type BagelQuestionUpdatePathVariables = {
	gameId: string;
	bagelId: string;
	id: string;
};
export type BagelQuestionUpdateV3PathVariables = {
	gameId: string;
	bagelId: string;
	id: string;
};

@Injectable()
export class BagelQuestionService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated use updateV3 instead
	 */
	public update(
		path: BagelQuestionUpdatePathVariables,
		body: UpdateBagelQuestionRequest,
	): Observable<BagelQuestion> {
		return this.http.patch<BagelQuestion>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/bagels/${path.bagelId}/questions/${path.id}`,
			body,
		);
	}

	public updateV3(
		path: BagelQuestionUpdateV3PathVariables,
		body: UpdateBagelQuestionV3Request,
	): Observable<BagelQuestion> {
		return this.http.patch<BagelQuestion>(
			`${this.config.apiUrl}/api/v3/private/games/${path.gameId}/phases/bagels/${path.bagelId}/questions/${path.id}`,
			body,
		);
	}
}
